import './Sections.scss';

function Sections(props) {
return (
    <div className='section'>
        <div className='wrapper'>
            <div className='sectionList'>
                <div className='line'>
                    <div className='block'>
                        <p className='title'>
                            {props.card.blocks[0].title}
                        </p>
                        <p className='text'>
                            {props.card.blocks[0].text}
                        </p>
                    </div>
                    <div className='block'>
                        <p className='title'>
                            {props.card.blocks[1].title}
                        </p>
                        <p className='text'>
                            {props.card.blocks[1].text}
                        </p>
                    </div>
                </div>
                <div className='line'>
                    <div className='block'>
                        <p className='title'>
                            {props.card.blocks[2].title}
                        </p>
                        <p className='text'>
                            {props.card.blocks[2].text}
                        </p>
                    </div>
                    {props.card.blocks[3] 
                        ? (
                        <div className='block'>
                            <p className='title'>
                                {props.card.blocks[3].title}
                            </p>
                            <p className='text'>
                                {props.card.blocks[3].text}
                            </p>
                        </div>)
                        : ""}
                    </div>
            </div>
        </div>
    </div>
)}
export default Sections;